export const REACT_APP_URL_PRIVACY_POLICY =
  process.env.REACT_APP_URL_PRIVACY_POLICY || ''
export const REACT_APP_URL_DO_NOT_SELL_INFORMATION =
  process.env.REACT_APP_URL_DO_NOT_SELL_INFORMATION || ''
